import React from 'react'
import PropTypes from 'prop-types'
import './PlayPauseButton.scss'

const PlayPauseButton = ({isPlaying, isEnd, onPlay, onPause, onRestart, disabled}) => {
  const handlePauseKeyDown = (e) => {
    if (e.keyCode === 13) {
      onPause()
    }
  }

  const handleRestartKeyDown = (e) => {
    if (e.keyCode === 13) {
      onRestart()
    }
  }

  const handlePlayKeyDown = (e) => {
    if (e.keyCode === 13) {
      onPlay()
    }
  }

  return (
    <div styleName="button-container">
      {isPlaying
        ? (
          <div
            data-id="pause-button"
            styleName="pause"
            onClick={onPause}
            data-bi-target="preview-pause-button"
            tabIndex={0}
            onKeyDown={handlePauseKeyDown}
            aria-label="Pause"
            role="button"
          />
        )
        : isEnd
          ? (
            <div
              data-id="restart-button"
              styleName="restart"
              onClick={onRestart}
              tabIndex={0}
              onKeyDown={handleRestartKeyDown}
              aria-label="Restart"
              role="button"
            />
          )
          : disabled
            ? (
              <div data-id="play-button" styleName="play" />
            )
            : (
              <div
                data-id="play-button"
                styleName="play"
                onClick={onPlay}
                data-bi-target="preview-play-button"
                tabIndex={0}
                onKeyDown={handlePlayKeyDown}
                aria-label="Play"
                role="button"
              />
            )}
    </div>
  )
}

PlayPauseButton.propTypes = {
  isPlaying: PropTypes.bool.isRequired,
  isEnd: PropTypes.bool.isRequired,
  onPlay: PropTypes.func.isRequired,
  onPause: PropTypes.func.isRequired,
  onRestart: PropTypes.func.isRequired
}

export default PlayPauseButton
